import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/user/login/login.component.scss.shim.ngstyle.ts